<template>
  <div class="table-content">
    <div class="content">
      <div class="nc-icon">
        <div class="nc-icon-body">
          <i :class="`mdi mdi-${icon} font-size-24`"></i>
        </div>
      </div>
      <div class="result-text-body">
        <span class="result-text" v-html="title"/>
      </div>
      <div class="result-subtext-body">
        <span class="result-subtext" v-html="subtitle"/>
      </div>
      <div class="mt-2">
        <slot name="btn">
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoResult",
  props: {
    title: {
      default: ''
    },
    subtitle: {
      default: ''
    },
    btn: {
      default: ''
    },
    icon: {
      default: ''
    }
  }
}
</script>

<style scoped>
.table-content {
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 360px;
}

.content {
  display: inline-block;
}

.nc-icon {
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(64, 68, 82, 0.08), 0 1px 1px 0 rgba(0, 0, 0, 0.12);
  overflow: hidden;
  background-color: #fff;
  box-sizing: border-box;
  display: inline-block;
}

.nc-icon-body {
  padding: 8px 12px 6px 12px;
  background-color: rgb(246, 248, 250);
  box-sizing: border-box;
}

.result-text-body {
  padding-top: 20px;
  box-sizing: border-box;
}

.result-text {
  white-space: normal;
  line-height: 28px;
  font-weight: 700;
  font-size: 20px;
  display: inline;
  color: rgb(26, 27, 37);
}

.result-subtext-body {
  padding-top: 4px;
  box-sizing: border-box;
}

.result-subtext {
  color: rgb(106, 115, 131);
  white-space: normal;
  font-size: 14px;
  display: inline;
  line-height: 20px;
}
</style>